module.exports = __webpack_public_path__ + "static/media/icon_t.fd226d66.svg";